// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"link__msignaturepad___3_PAX","m-signature-pad--body":"link__m-signature-pad--body___3QRh9","m-signature-pad--footer":"link__m-signature-pad--footer___1GpLG","description":"link__description___79h_W","button":"link__button___3YbrU","clear":"link__clear___2iBuB","save":"link__save___17Zvn","m-signature-pad":"link__m-signature-pad___HfYKu","github":"link__github___1mbz7","link":"link__link___1gEkC","navLink":"link__navLink___2VUtW","itemText":"link__itemText___2AO70","hidden":"link__hidden___2y7Pv"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/NavigationBar/link.scss
// module id = F/03
// module chunks = client